(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
function initMomentCatalog(root){
  if(!root || root.dataset.initialized)return;
  root.dataset.initialized='true';
  const links=[...root.querySelectorAll('[data-group]')];
  const description=root.querySelector('[data-catalog-description]');
  const current=links.find(link=>link.hasAttribute('aria-current'));
  if(current)description.textContent=current.dataset.description;
  if(!root.hasAttribute('data-all-catalog') || !root.querySelector('[data-single-page]'))return;
  const cards=[...root.querySelectorAll('[data-memberships]')];
  const count=root.querySelector('[data-catalog-count]');
  const empty=root.querySelector('[data-catalog-empty]');
  function apply(group){
    const selected=links.find(link=>link.dataset.group===group)||links[0];
    let visible=0;
    cards.forEach(card=>{card.hidden=selected.dataset.group!=='all'&&!card.dataset.memberships.split(' ').includes(selected.dataset.group);if(!card.hidden)visible++;});
    links.forEach(link=>{if(link===selected)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
    description.textContent=selected.dataset.description;
    count.textContent=count.dataset.countTemplate.replace('__COUNT__',visible);
    empty.hidden=visible!==0;
  }
  apply(new URL(location.href).searchParams.get('collezione')||'all');
  links.forEach(link=>link.addEventListener('click',event=>{
    if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;
    event.preventDefault();
    const url=new URL(location.href);
    if(link.dataset.group==='all')url.searchParams.delete('collezione');else url.searchParams.set('collezione',link.dataset.group);
    history.pushState(null,'',url);
    apply(link.dataset.group);
  }));
  window.addEventListener('popstate',()=>apply(new URL(location.href).searchParams.get('collezione')||'all'));
}
document.querySelectorAll('.moment-catalog').forEach(initMomentCatalog);
document.addEventListener('shopify:section:load',event=>{if(event.target.matches('.moment-catalog'))initMomentCatalog(event.target);else event.target.querySelectorAll('.moment-catalog').forEach(initMomentCatalog);});

  } catch(e) { console.error(e); }
})();
})();
